module.exports = __webpack_public_path__ + "img/shortcut_toff_off.f114a89d.svg";